"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PasswordForm = exports.AppNameForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var Yup = _interopRequireWildcard(require("yup"));
var _reactI18next = require("react-i18next");
var _formik = require("formik");
var _Input = _interopRequireWildcard(require("../Input"));
var _CircularLoader = _interopRequireDefault(require("../CircularLoader"));
var _FormErrorMessage = _interopRequireDefault(require("../FormErrorMessage"));
var _FormLabel = _interopRequireDefault(require("../FormLabel"));
var _Button = _interopRequireDefault(require("../Button"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var loader = /*#__PURE__*/_react["default"].createElement(_CircularLoader["default"], {
  size: 24,
  color: "inherit"
});
var AppNameForm = exports.AppNameForm = function AppNameForm(_ref) {
  var validationSchema = _ref.validationSchema,
    isLoading = _ref.isLoading,
    onBack = _ref.onBack,
    onSubmit = _ref.onSubmit;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    onSubmit: onSubmit,
    initialValues: {
      name: ''
    },
    validationSchema: Yup.object().shape({
      name: validationSchema.max(30, t('settings.asp.form.appName.maximum', {
        max: 30
      })).required(t('required'))
    })
  }, function (_ref2) {
    var isValid = _ref2.isValid;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "flex flex-col flex-1"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: "name",
      className: "text-sm"
    }, t('settings.asp.form.appName.label')), /*#__PURE__*/_react["default"].createElement(_Input["default"], {
      autoFocus: true,
      size: "lg",
      name: "name",
      autocomplete: "off",
      placeholder: "e.g. Edison Mail",
      className: "w-full font-bold"
    }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "name",
      showAfterTouch: false
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-8 flex"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "button",
      className: "mr-2 w-32",
      color: "secondary",
      onClick: onBack
    }, t('button.back')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "submit",
      className: "w-32",
      disabled: !isValid || isLoading
    }, isLoading ? loader : t('button.generate'))));
  });
};
var PasswordForm = exports.PasswordForm = function PasswordForm(_ref3) {
  var isLoading = _ref3.isLoading,
    onBack = _ref3.onBack,
    onSubmit = _ref3.onSubmit;
  var formik = (0, _react.useRef)(null);
  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
    t = _useTranslation2.t;
  function handleOnSubmit(_ref4) {
    var password = _ref4.password;
    Promise.resolve(onSubmit({
      password: password
    }))["catch"](function () {
      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        message = _ref5.message;
      var formikRef = formik.current;
      if (formikRef) {
        formikRef.setFieldError('password', message);
      }
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
    ref: formik,
    onSubmit: handleOnSubmit,
    initialValues: {
      passwords: ''
    },
    validationSchema: Yup.object().shape({
      password: Yup.string().required(t('required'))
    })
  }, function (_ref6) {
    var isValid = _ref6.isValid;
    return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
      className: "flex flex-col flex-1 pt-6"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex-1"
    }, /*#__PURE__*/_react["default"].createElement(_Input.PasswordInput, {
      autoFocus: true,
      visibleToggle: true,
      size: "lg",
      name: "password",
      autocomplete: "off",
      placeholder: "Password",
      className: "w-full font-bold"
    }), /*#__PURE__*/_react["default"].createElement(_FormErrorMessage["default"], {
      name: "password"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pt-8"
    }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      type: "submit",
      className: "w-32",
      disabled: !isValid || isLoading
    }, isLoading ? loader : t('button.next'))));
  });
};
//# sourceMappingURL=Forms.js.map